export default __webpack_public_path__ + "static/media/marker.0bdab163.svg";